import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProduitService } from '../services/produit.service';
import { SnackBarService } from '../services/snack-bar.service';
import { ZoneService } from '../services/zone.service';

@Component({
  selector: 'app-delete-camion',
  templateUrl: './delete-camion.component.html',
  styleUrls: ['./delete-camion.component.scss']
})
export class DeleteCamionComponent implements OnInit {

  
  constructor(public dialogRef: MatDialogRef<DeleteCamionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private produitService: ProduitService,private zoneService: ZoneService, private _snackBar: SnackBarService) { }

  ngOnInit(): void {
  }
  onClickYes(){
    this.zoneService.deleteCamion(this.data.id).subscribe(res => {
      this.dialogRef.close();
      this._snackBar.openSnackBar("Supression Reuissie!!", "Fermer");
    });
  }

  onClickNo(){
    this.dialogRef.close();
  }

}
